import { createSelector } from '@reduxjs/toolkit';

export const selectMinerState = state => state.miner;
export const selectMinerById = (state, minerID) =>
  state.miner.miners.find(miner => miner.id === minerID);
export const selectAllMinerTypes = state => state.miner.minerTypes;
export const selectMinerTypesLoaded = state => state.miner.minerTypesLoaded;
export const selectMinerConsumption = state => state.miner.minerConsumption;
export const selectMinerLoading = state => state.miner.isLoading;
export const selectMinerError = state => state.miner.error;
export const selectAllMiners = state => state.miner.miners;
export const selectActiveInactiveMinersCount = createSelector(
  [selectMinerState],
  miner => ({
    activeMiners: miner.activeMiners,
    inactiveMiners: miner.inactiveMiners
  })
);

export const selectMinersLoaded = state => state.miner.minersLoaded;
export const selectDevicePage = state => state.miner.devicePage;
